export const getDashboardUrl = store => {
  return `https://${store.constructorDomain}/sites/url/${store.siteUrl}/dashBoard`;
};

export const getPublishedSiteDomain = store => {
  return store.publishedSiteDomain;
};

export const getPublishedSiteUrl = store => {
  return `http://${getPublishedSiteDomain(store)}`;
};

export const getBuyDomainLink = store => {
  const dashboardUrl = getDashboardUrl(store);
  return `${dashboardUrl}/domains/buy/search`;
};

// TODO: fix boost link
export const getBoostLink = store => {
  const dashboardUrl = getDashboardUrl(store);
  return dashboardUrl;
};
